import { initComponent } from "./components/initComponent";
import { simpleSlider } from "./components/simpleSlider";

initComponent();

if (document.querySelector(".our-customers__container")) {
  simpleSlider(
    document.querySelector(".our-customers__container"),
    false,
    1,
    10000
  );
}
